import { React, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { signInStart, signInSuccess, signInFailure } from '../redux/staff/staffSlice';
import { TextField, Typography, Container, Button, Box } from "@mui/material";

//sign in page for staff to sign in to the staff part of the app
export default function SignIn() {

  const [formData, setFormData] = useState({});
  const { loading, error } = useSelector((state) => state.staff);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      dispatch(signInStart());
      const result = await fetch("/sign-in",
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(formData),
        }
      )
      const data = await result.json();
      if (data.status_code !== 200) {
        dispatch(signInFailure(data.message));
        return;
      }
      dispatch(signInSuccess(data));
      navigate('/');

    } catch (err) {
      dispatch(signInFailure(err.message));
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.id]: e.target.value,
    })
  };

  return (
    <>
      <Container sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'row', flexWrap: 'wrap' }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', flexWrap: 'wrap', m: 1, padding: 5 }}>
          <Typography variant="h4" align="center" sx={{ fontWeight: 'bold' }}>Staff Sign in</Typography>
          <form onSubmit={handleSubmit} >
            <div>
              <TextField
                id="employeeId"
                label="Employee ID"
                type="number"
                variant="outlined"
                sx={{ mt: 2, width: 300 }}
                onChange={handleChange}
              />
            </div>
            <div>
              <TextField
                id="password"
                label="Password"
                type="password"
                autoComplete="current-password"
                variant="outlined"
                sx={{ mt: 2, width: 300 }}
                onChange={handleChange}
              />
            </div>
            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
              <Button onClick={handleSubmit} sx={{
                width: 300, backgroundColor: "black",
                ':hover': {
                  color: 'black',
                  bgcolor: 'grey'
                }
              }} size="medium" variant="contained" disabled={loading}>
                {loading ? "Loading..." : "Sign In"}
              </Button>
            </Box>
          </form>
          <Box sx={{ mt: 2 }} align="center">
            <Link to={"/sign-in"}>
              <span>Forgot your password?</span>
            </Link>
          </Box>
          {error && <p style={{ color: 'red' }}>{error}</p>}
        </Box>
      </Container>
    </>
  );
}